import { Switch } from "@swivl-mono/ui";
import React from "react";

import "./NavBar.Switch.scss";

interface Props {
  on: boolean;
  onChange: (on: boolean) => void;
  name?: string;
  analytics?: any;
  children?: any;
  isInRightCol?: boolean;
}

export class NavBarSwitch extends React.Component<Props> {
  render() {
    const switchComp = <Switch on={this.props.on} onChange={this.props.onChange} name={this.props.name} />;
    if (this.props.children) {
      return (
        <div className="NavBarSwitch">
          <label>{this.props.children}</label>
          {switchComp}
        </div>
      );
    }
    return switchComp;
  }
}
